import styled from 'styled-components';
import CreateAddress from 'components/form/AddressSelector/Items/CreateAddress/container';

export default styled(CreateAddress)`
  border-top: 1px solid var(--grey300);
  padding: 1.2rem;
`;
